<template>
  <v-dialog v-model="show" width="30vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"> Confirmación </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col>
                <span v-if="title">
                  {{ title }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  outlined
                  dense
                  return-object
                  item-text="text"
                  label="Selecciona motivo de contaminación"
                  :items="contaminations"
                  v-model="contamination"
                  :rules="validation()"
                >
                </v-combobox>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="confirmation"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    loader: false,
    isLoading: false,
    contaminations: [
      { text: "Bacterias", value: "bacteria" },
      { text: "Hongo", value: "fungi" },
    ],
    contamination: null,
  }),
  props: {
    value: Boolean,
    title: String,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    closeModal() {
      this.show = false;
    },

    confirmation() {
      //emit desision
      if (this.$refs.form.validate()) {
        this.$emit("confirmation", this.contamination);
        this.closeModal();
      }
    },
     validation(name) {
      return requiredValidation(name);
    },
  },
  watch: {
    show(value) {
      if (!value) {
        this.contamination = null;
      }
    },
  },
};
</script>